import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FsLightbox from "fslightbox-react";
import winner1 from "../../../assets/winner_22/winner1.jpg";
import winner10 from "../../../assets/winner_22/winner10.jpg";
import runnerup5 from "../../../assets/runner_22/runner5.jpg";
import winner4 from "../../../assets/winner_22/winner4.jpg";
import runnerup2 from "../../../assets/runner_22/runnerup2.jpg";
import winner5 from "../../../assets/winner_22/winner5.jpg";
import runnerup3 from "../../../assets/runner_22/runnerup3.jpg";
import winner8 from "../../../assets/winner_22/winner8.jpg";
import winner3 from "../../../assets/winner_22/winner3.jpg";
import winner9 from "../../../assets/winner_22/winner9.jpg";
import runnerup4 from "../../../assets/runner_22/runnerup4.jpg";
import winner2 from "../../../assets/winner_22/winner2.jpg";
import runnerup1 from "../../../assets/runner_22/runnerup1.jpg";
import winner6 from "../../../assets/winner_22/winner6.jpg";
import winner7 from "../../../assets/winner_22/winner7.jpg";

const photos = [
  {
    src: winner10,
    title: "Winner, Oby Ezekwesili Award (for Women Advocacy) ",
  },
  {
    src: runnerup5,
    title: "First Runner-up, Oby Ezekwesili Award (for Women Advocacy) ",
  },
  {
    src: winner4,
    title: "Winner, Award for Community Service",
  },
  {
    src: runnerup2,
    title: "First Runner-up, Award for Community Service",
  },
  {
    src: winner5,
    title: "Winner, Disability Advocacy / Empowerment Award",
  },
  {
    src: runnerup3,
    title: "First Runner-up, Disability Advocacy / Empowerment Award",
  },
  {
    src: winner9,
    title: "Winner, Solutions Journalism Award",
  },
  {
    src: runnerup4,
    title: "First Runner-up, Solutions Journalism Award",
  },
  {
    src: winner2,
    title: "Winner, Award for Civic Activism",
  },
  {
    src: runnerup1,
    title: "First Runner-up, Award for Civic Activism",
  },
  {
    src: winner1,
    title: "Winner, Art for Activism",
  },
  {
    src: winner8,
    title: "Winner, Award for Institutional Transparency (Government Agencies)",
  },
  {
    src: winner3,
    title: "Winner, Corporate Award for Civic Investments - (For-Profit)",
  },
  {
    src: winner7,
    title: "Winner, Award for Inclusion & Diversity",
  },
  {
    src: winner6,
    title: "Winner, Hall of Fame Award for Civic Activism",
  },
];

const WinnerList = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box marginTop={{ xs: "25%", sm: "0%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"left"}
        flexWrap={"wrap"}
      >
        {photosToShow.map((item, index) => (
          <Box
            width={{ xs: "95%", sm: "23%" }}
            marginBottom={{ xs: "5%", sm: "2%" }}
          >
            <Box
              component="img"
              height={{ xs: "40vh", sm: "37vh" }}
              onClick={() => setIsViewerOpen(index)}
              sx={{
                width: "100%",
                borderRadius: 2,
                cursor: "pointer",
              }}
              src={item.src}
              alt={item.title}
            />
            <Box>
              <Typography
                variant={"body2"}
                fontWeight={500}
                color={"#049593"}
                textAlign="center"
              >
                {item.title}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <FsLightbox
        toggler={isViewerOpen}
        sources={[
          winner10,
          runnerup5,
          winner4,
          runnerup2,
          winner5,
          runnerup3,
          winner9,
          runnerup4,
          winner2,
          runnerup1,
          winner1,
          winner8,
          winner3,
          winner7,
          winner6,
        ]}
      />
    </Box>
  );
};

export default WinnerList;
